angular
	.module('AutoPrequal')
	.controller('reviewTermsCtrl', reviewTermsCtrl);

reviewTermsCtrl.$inject = ['$http', '$scope', '$rootScope', '$timeout', 'ScrollFactory', 'DataFactory', 'SessionFactory', 'LocalizationFactory', 'ErrorFactory'];

function reviewTermsCtrl($http, $scope, $rootScope, $timeout, ScrollFactory, DataFactory, SessionFactory, LocalizationFactory, ErrorFactory) {

	$rootScope.progressCurrent = 9;
	$rootScope.progressMobCurrent = 9;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.reviewTerms;
	$scope.forceFRTerms = false;
	$scope.showOOWModal = false;
	$scope.showNoMatchModal = false;
	$scope.firstOOWQuestion = true;
	$scope.temp = {
		'selectedOpt': "",
		'secondSelectedOpt': ""
	}

	$scope.data = DataFactory.appData.applicant;

	$scope.$watch('data', function (newData, oldData) {
		if ((newData.apFirstName !== oldData.apFirstName
			|| newData.apLastName !== oldData.apLastName
			|| newData.apPhone !== oldData.apPhone
			|| newData.apAddress !== oldData.apAddress
			|| newData.apBirthDate !== oldData.apBirthDate)
			&& newData.score) {
			$scope.termRead = false;
			$scope.data.termRead = false;
			$rootScope.termsAccepted = false;
			$scope.temp = {
				'selectedOpt': "",
				'secondSelectedOpt': ""
			}
			$scope.firstOOWQuestion = true;
			$scope.secondOOWQuestion = false;
			$scope.data.secondQuestion = false;
			$scope.data.attempts = 0;
			$scope.data.score = "";
			$scope.data.primaryConsentID = "";
			ScrollFactory.lastVisibleStep("reviewTerms");
		}
	}, true);

	$rootScope.reviewTermsNextStep = function () {
		DataFactory.appData.applicant.appState.reviewTerms = true;

		$scope.data.termRead = true;

		$rootScope.termsAccepted = true;

		if (!$scope.data.primaryConsentID || !$scope.data.score) {

			var sid = SessionFactory.getCurrentSession();

			if (!sid) return;

			var consentObj = JSON.stringify({
				'id': sid,
				'firstName': LocalizationFactory.mapFrChar($scope.data.apFirstName),
				'lastName': LocalizationFactory.mapFrChar($scope.data.apLastName),
				'streetAddress': LocalizationFactory.mapFrChar($scope.data.apAddress),
				'apt': $scope.data.apApt,
				'city': LocalizationFactory.mapFrChar($scope.data.apCity),
				'province': $scope.data.apProvince,
				'postalCode': $scope.data.apPostalCode.replace(/\s/g, "").toUpperCase(),
				'DOB': $scope.data.apBirthDate,
				'emailAddress': $scope.data.apEmail,
				'phoneNumber': $scope.data.apPhone.replace(/-/g, ""),
				'applicantType': 'primary',
				'consentVersionNumber': '1.0'
			});

			$rootScope.forcedLoader = true;
			$http({
				method: 'POST',
				url: baseUrl + "api/consent/post",
				data: consentObj
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] === "0") {
					$scope.data.primaryConsentID = data["result_content"];
					DataFactory.setData($scope.data).then(function () {
						handleOOW();
					})
				}
				else {
					$rootScope.forcedLoader = false;
					ErrorFactory.errorPage(data['result_code'], $rootScope.lang, "Consent Result code invalid", data["result_content"]);
				}
			}, function (httpError) {
				$rootScope.forcedLoader = false;
				if (httpError.status) {
					ErrorFactory.errorPage("CSE-" + httpError.status, "en", "Consent failed with http status", $rootScope.glContent.errors.generic_connection_error);
				}
				else {
					ErrorFactory.errorPage("CSU", "en", "Consent failed with unknown error", $rootScope.glContent.errors.generic_connection_error);
				}
			});

		}
		else if ($scope.data.primaryConsentID && $scope.data.score) {
			SessionFactory.retrieveCurrentSession(SessionFactory.sessionId).then(function () {
				DataFactory.setData($scope.data);
				ScrollFactory.showStep("tradein");
				ScrollFactory.goToStep("tradein");
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("applicantMortgage");
		ScrollFactory.goToStep("applicantMortgage");
	}

	$scope.swapForFRTerms = function () {
		$scope.forceFRTerms = true;
	}
	$scope.swapForENTerms = function () {
		$scope.forceFRTerms = false;
	}

	function handleOOW() {
		var initialOOWObj = JSON.stringify({
			'firstName': LocalizationFactory.mapFrChar($scope.data.apFirstName),
			'lastName': LocalizationFactory.mapFrChar($scope.data.apLastName),
			'street': $scope.data.apStreetNum + ' ' + LocalizationFactory.mapFrChar($scope.data.apStreetName),
			'city': LocalizationFactory.mapFrChar($scope.data.apCity),
			'prov': $scope.data.apProvince,
			'postalCode': $scope.data.apPostalCode.replace(/\s/g, "").toUpperCase(),
			'DOB': $scope.data.apBirthDate,
			'phone': $scope.data.apPhone.replace(/-/g, ""),
			'language': $rootScope.lang
		});
		$http({
			method: 'POST',
			url: baseUrl + "api/OOW/question",
			data: initialOOWObj
		}).then(function (response) {
			var data;
			try {
				data = JSON.parse(response.data);
			} catch (e) {
				data = response.data
			};
			var OOWResponse = data['result_content'];
			if (data['result_code'] === "0") {
				$scope.ExamDetails = OOWResponse.ExamDetails;
				$scope.ApplicationId = OOWResponse.ApplicationId;
				$scope.QueueName = OOWResponse.CurrentQueue;
				$scope.question = OOWResponse.ExamDetails.QuestionsList.Question.Text;
				$scope.choices = [
					OOWResponse.ExamDetails.QuestionsList.Question.Answer[0].Text,
					OOWResponse.ExamDetails.QuestionsList.Question.Answer[1].Text,
					OOWResponse.ExamDetails.QuestionsList.Question.Answer[2].Text,
					OOWResponse.ExamDetails.QuestionsList.Question.Answer[3].Text,
					OOWResponse.ExamDetails.QuestionsList.Question.Answer[4].Text
				];
				$scope.showOOWModal = true;
				$rootScope.gaPageView.oow();
			} else {

				var splitCode = data['result_code'].split("-");
				if (splitCode[0] == "OOWQN99") {
					if (splitCode[1] === "01") {
						if (!$scope.data.attempts) $scope.data.attempts = 0;
						$scope.data.attempts += 1;
						DataFactory.setData($scope.data);
						if (Number($scope.data.attempts) >= 2) {
							//auth error error-identity-not-found-2nd-attempt-fail
							//no edit
							$rootScope.ga.oowErrors.idNotFound();
							ErrorFactory.errorPage("OOWQ2T", $rootScope.lang, $rootScope.glContent.errors.attempt_err_msg, "No match after 2 tries", true);
						} else {
							//user error error-identity-not-found-1st-attempt-fail
							//editable
							$scope.showNoMatchModal = true;
							$rootScope.ga.oowErrors.idNotFound2();
						}
					} else {
						if (splitCode[1] === "02") {
							//auth error error-identity-TU-thinfile
							ErrorFactory.errorPage("OOWQTF", $rootScope.lang, $rootScope.glContent.errors.auth_err_msg, data['result_content'], true);
						} else if (splitCode[1] === "03") {
							//repeat error error-identity-repeat-attempt
							$rootScope.ga.oowErrors.idNotFound();
							ErrorFactory.errorPage("OOWQRA", $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
						} else {
							//server error error-identity-TU-serverfail
							$rootScope.ga.oowErrors.tuServerfail();
							ErrorFactory.errorPage("OOWQTU-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
						}
					}
				} else {
					//server error error-identity-TU-serverfail
					$rootScope.ga.oowErrors.tuServerfail();
					ErrorFactory.errorPage("OOWQTU-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
				}
			}
			$rootScope.forcedLoader = false;
		}, function (httpError) {
			$rootScope.forcedLoader = false;
			if (httpError.status) {
				ErrorFactory.errorPage("OOWQE-" + httpError.status, "en", $rootScope.glContent.errors.generic_connection_error, "Question Retrieve failed with http status");
			} else {
				ErrorFactory.errorPage("OOWQU", "en", $rootScope.glContent.errors.generic_connection_error, "Question failed with unknown error");
			}
		});
	}
	$scope.tryAgain = function tryAgain() {
		$scope.showNoMatchModal = false;
		$scope.termRead = false;
		$scope.data.termRead = false;
		$scope.data.primaryConsentID = '';
		$rootScope.termsAccepted = false;
		$scope.temp = {
			'selectedOpt': "",
			'secondSelectedOpt': ""
		}
		ScrollFactory.goToStep('applicantName');
	}
	$scope.OOWAnswer = function OOWAnswer(answer) {
		$scope.ExamDetails.QuestionsList.Question.Answer[Number(answer)].IsSelected = "true";
		var firstOOWObj = JSON.stringify({
			'SessionId': SessionFactory.sessionId,
			'ApplicationId': $scope.ApplicationId,
			'ExamDetails': $scope.ExamDetails,
			'QueueName': $scope.QueueName
		});
		$http({
			method: 'POST',
			url: baseUrl + "api/OOW/answer",
			data: firstOOWObj
		}).then(function (response) {
			var data;
			try {
				data = JSON.parse(response.data);
			} catch (e) {
				data = response.data
			};
			var OOWResponse = data['result_content'];
			if (data['result_code'] === "0") {
				var decision = OOWResponse['Decision'] ? OOWResponse['Decision'].toLowerCase() : "";
				var qfreeze = OOWResponse['QFreeze'];


				if (decision == 'fail') {
					if ($scope.data.secondQuestion) {
						//game over
						ErrorFactory.errorPage("A2T", $rootScope.lang, $rootScope.glContent.errors.too_many_tries, "Second OOW Answer Wrong", true);
					}
				}
				else if (!OOWResponse['Decision'] && OOWResponse['ExamDetails']) {
					$scope.ExamDetails = OOWResponse.ExamDetails;
					$scope.ApplicationId = OOWResponse.ApplicationId;
					$scope.QueueName = OOWResponse.CurrentQueue;
					$scope.second_question = OOWResponse.ExamDetails.QuestionsList.Question.Text;
					$scope.second_choices = [
						OOWResponse.ExamDetails.QuestionsList.Question.Answer[0].Text,
						OOWResponse.ExamDetails.QuestionsList.Question.Answer[1].Text,
						OOWResponse.ExamDetails.QuestionsList.Question.Answer[2].Text,
						OOWResponse.ExamDetails.QuestionsList.Question.Answer[3].Text,
						OOWResponse.ExamDetails.QuestionsList.Question.Answer[4].Text
					];
					$scope.firstOOWQuestion = false;
					$scope.secondOOWQuestion = true;
					$scope.data.secondQuestion = true;
					DataFactory.setData($scope.data);
				}
				else if (decision == 'pass') {
					//winner
					$scope.data.score = OOWResponse['Decision'];
					$scope.showOOWModal = false;
					$rootScope.reviewTermsNextStep();
				}
			} else {
				var splitCode = data['result_code'].split("-");
				if (splitCode[0] == "OOWQN99") {
					if (splitCode[1] === "02") {
						//auth error error-identity-TU-thinfile
						ErrorFactory.errorPage("OOWATF", $rootScope.lang, $rootScope.glContent.errors.auth_err_msg, data['result_content'], true);
					} else if (splitCode[1] === "03") {
						//repeat error error-identity-repeat-attempt
						$rootScope.ga.oowErrors.idNotFound();
						ErrorFactory.errorPage("OOWARA", $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
					}
					else {
						//server error error-identity-TU-serverfail
						$rootScope.ga.oowErrors.tuServerfail();
						ErrorFactory.errorPage("OOWATU-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
					}
				} else if (splitCode[0] == "OOWAN119") {

					$rootScope.gaCustEvent.oowQFreezeFailure();// qfreeze
					ErrorFactory.errorPage("OOWATU-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
				}
				else {
					//server error error-identity-TU-serverfail
					$rootScope.ga.oowErrors.tuServerfail();
					ErrorFactory.errorPage("OOWATU-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
				}
			}
		}, function (httpError) {
			if (httpError.status) {
				ErrorFactory.errorPage("OOWAE-" + httpError.status, "en", $rootScope.glContent.errors.generic_connection_error, "First answer failed with http status");
			} else {
				ErrorFactory.errorPage("OOWAU", "en", $rootScope.glContent.errors.generic_connection_error, "First answer failed with unknown error");
			}
		});
	}
	$scope.OOWSecondAnswer = function OOWSecondAnswer(answer) {
		$scope.ExamDetails.QuestionsList.Question.Answer[Number(answer)].IsSelected = "true";
		var secondOOWObj = JSON.stringify({
			'SessionId': SessionFactory.sessionId,
			'ApplicationId': $scope.ApplicationId,
			'ExamDetails': $scope.ExamDetails,
			'QueueName': $scope.QueueName
		});
		$http({
			method: 'POST',
			url: baseUrl + "api/OOW/answer",
			data: secondOOWObj
		}).then(function (response) {
			var data;
			try {
				data = JSON.parse(response.data);
			} catch (e) {
				data = response.data;
			};

			if (data['result_code'] === "0") {
				var decision = data.result_content.Decision ? data.result_content.Decision.toLowerCase() : "";
				if (decision == 'fail') {
					//game over
					ErrorFactory.errorPage("A2T", $rootScope.lang, $rootScope.glContent.errors.too_many_tries, "Second OOW Answer Wrong", true);
				} else if (decision == 'pass') {
					//winner
					$scope.data.score = decision;
					$scope.showOOWModal = false;
					$rootScope.reviewTermsNextStep();
				}
			} else {
				var splitCode = data['result_code'].split("-");
				if (splitCode[0] == "OOWQN99") {
					if (splitCode[1] === "02") {
						//auth error error-identity-TU-thinfile
						ErrorFactory.errorPage("OOWATF2", $rootScope.lang, $rootScope.glContent.errors.auth_err_msg, data['result_content'], true);
					} else if (splitCode[1] === "03") {
						//repeat error error-identity-repeat-attempt
						$rootScope.ga.oowErrors.idNotFound();
						ErrorFactory.errorPage("OOWARA2", $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
					} else {
						//server error error-identity-TU-
						$rootScope.ga.oowErrors.tuServerfail();
						ErrorFactory.errorPage("OOWATU2-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
					}
				} else {
					//server error error-identity-TU-serverfail
					$rootScope.ga.oowErrors.tuServerfail();
					ErrorFactory.errorPage("OOWATU2-" + data['result_code'], $rootScope.lang, $rootScope.glContent.errors.int_err_msg, data['result_content'], true);
				}
			}
		}, function (httpError) {
			if (httpError.status) {
				ErrorFactory.errorPage("OOWAE2-" + httpError.status, "en", $rootScope.glContent.errors.generic_connection_error, "Second answer failed with http status");
			} else {
				ErrorFactory.errorPage("OOWAU2", "en", $rootScope.glContent.errors.generic_connection_error, "Second answer failed with unknown error");
			}
		});
	}
}
